export const ADD_URL_POPUP = {
	CHANNEL: 'Channel Name',
	URL: 'Add Live Channel URL',
	ADD: 'Add',
	CANCEL: 'Cancel',
	UPLOAD_URL_ERROR: 'Error occurs while uploading file, Please try again.',
};
